import script from "./FeatureBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeatureBanner.vue?vue&type=script&lang=ts&setup=true"

import "./FeatureBanner.vue?vue&type=style&index=0&id=ec6164d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec6164d2"]])

export default __exports__